<template>
  <div
    :class="{
      'content-summary-snippet': true,
      'content-summary-snippet--darkened': props.isDragNDropGhost,
    }"
  >
    <div
      :class="{
        'content-summary-snippet__delete-button-wrap': true,
        'content-summary-snippet__delete-button-wrap--darkened': props.isDragNDropGhost,
      }"
    >
      <CircleWithIconBtn
        v-if="props.isUnbindButtonVisible"
        :class="{
          'content-summary-snippet__delete-button': true,
          'content-summary-snippet__delete-button--invisible': props.isDragNDropGhost,
        }"
        iconName="scissors_3"
        iconColor="rgba(180, 80, 80, 1)"
        iconColorHover="rgba(180, 80, 80, 1)"
        color="white"
        :iconSize="16"
        size="big"
        @click="emit('clickDelete')"
      />
    </div>

    <div
      v-if="props.isContentSourcedFromLabelVisible"
      :class="{
        'content-summary-snippet__title': true,
        'content-summary-snippet__title--darkened': props.isDragNDropGhost,
      }"
    >
      Content Sourced From
      <!--<Matched to {{ lodashStartCase(props.contentSummaryData.contextType) }}-->
    </div>

    <!-- Creator visit summary -->
    <div
      :class="{
        'creator-visit-summary': true,
        'content-summary-snippet__content': true,
        'content-summary-snippet__content--darkened': props.isDragNDropGhost,
      }"
    >
      <div class="creator-visit-summary__title-wrap">
        <span v-if="props.contentSummaryData.contextType === 'Location'" class="global-h4 creator-visit-summary__title">{{ props.contentSummaryData.contextName }}</span>
        <template v-else>
          <RouterLink class="global-h4 global-a global-a--gray creator-visit-summary__title" :to="contextSourceLink" target="_blank">
            {{ props.contentSummaryData.contextName }}
          </RouterLink>
          <IconEmbedded name="external-link_2" :size="17" color="rgba(0, 0, 0, 0.3)" style="margin-left: 3px; position: relative; top: 2px" />
        </template>

        <InfoIconWithTooltip v-if="props.matchRationale && !props.matchRationale.startsWith('LocationExternalId')" style="position: relative; top: 2px; margin-left: 4px">
          <b>Why this content?</b><br />{{ props.matchRationale }}
        </InfoIconWithTooltip>
      </div>

      <!--<div class="creator-visit-summary__thumbnails-row">-->
      <!--  <div class="creator-visit-summary__thumbnails-row-in-wrap">-->
      <!--    <SrpFileThumbnail-->
      <!--      class="creator-visit-summary__thumbnail"-->
      <!--      v-for="fileName in props.contentSummaryData.examples"-->
      <!--      :key="fileName"-->
      <!--      :fileName="fileName"-->
      <!--      :isFixedAspectRatio="false"-->
      <!--      :isWithLoader="false"-->
      <!--    />-->
      <!--  </div>-->
      <!--</div>-->

      <LinkWithIcon class="creator-visit-summary__assets-count-link" isDottedUnderline @click="emit('clickViewPhotos')">
        <template #icon><IconEmbedded name="image_2" :size="17" /></template>
        <span>Contains {{ props.contentSummaryData.assetCount }} Photos</span>
      </LinkWithIcon>
    </div>
    <!-- / Creator visit summary -->
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Types
import { ContentSummaryData } from "@contracts/contentCalendar";
import type { RouteLocationRaw } from "vue-router";

// Components
import CircleWithIconBtn from "@components/ui/CircleWithIconBtn.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import InfoIconWithTooltip from "@components/ui/InfoIconWithTooltip.vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";

const props = withDefaults(
  defineProps<{
    contentSummaryData: ContentSummaryData;
    matchRationale?: string | null;
    isUnbindButtonVisible: boolean;
    isDragNDropGhost?: boolean;
    customerId: string;
    isContentSourcedFromLabelVisible?: boolean;
  }>(),
  {
    matchRationale: null,
    isDragNDropGhost: false,
    isContentSourcedFromLabelVisible: true,
  }
);

const emit = defineEmits<{
  (e: "clickDelete"): void;
  (e: "clickViewPhotos"): void;
}>();

// Generates the Context Source Link ==========================================
const contextSourceLink = computed<RouteLocationRaw>(() => {
  return {
    CreatorVisit: {
      name: "PaidCollabCommunityAdmin",
      params: { communityId: props.customerId },
      hash: `#collab=${props.contentSummaryData.contextId}`,
    },
    CommunityUpload: {
      name: "CommunityPhotos",
      params: { pageId: props.customerId },
      hash: `#group=community-upload&sectionId=${props.contentSummaryData.contextId}`,
    },
    CustomerUpload: {
      name: "CommunityPhotos",
      params: { pageId: props.customerId },
      hash: `#group=my-uploads&sectionId=${props.contentSummaryData.contextId}`,
    },
  }[props.contentSummaryData.contextType];
});
</script>

<style scoped lang="scss">
@import "./contentSummarySnippet.scss";
@import "@/scss/variables.scss";

// Creator visit summary ======================================================
.creator-visit-summary {
  &__title-wrap {
    margin-bottom: 9px;
  }

  &__title {
    font-weight: 500;
  }

  &__thumbnails-row {
    width: calc(100% + 10px);
    height: 35px;
    margin-bottom: 9px;
    position: relative;
    z-index: 0;
    overflow: hidden;
    mask-image: linear-gradient(90deg, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 95%);
  }

  &__thumbnails-row-in-wrap {
    width: 1000px;
    height: 35px;
    gap: 4px;
    display: flex;
    position: absolute;
    inset: 0 auto auto 0;
  }

  &__thumbnail {
    height: 35px;
    border-radius: 3px;

    :deep(*) {
      border-radius: 3px !important;
    }
  }

  &__assets-count-link {
    @include standardFont;
    margin-left: -4px;
  }
}
</style>
